
  import { Component, Prop, Vue } from 'vue-property-decorator'

  import type { Badge } from '@/calendar/types'

  @Component({ name: 'AnnotationBadges' })
  export default class extends Vue {
    @Prop({ required: true })
    badges: Badge[]
  }
